import cookies from 'browser-cookies'
import { getBaseUrl, getCurrentOrgKey } from '..'
import invariant from 'invariant'

function getRequestHeaders(): HeadersInit {
  return {
    Authorization: getAuthorizationToken(),
    'X-CSRF-TOKEN': getCSRFToken(),
    'Content-Type': 'application/json',
  }
}

function getAuthorizationToken() {
  return localStorage.getItem('workflow-token') ?? ''
}

function getCSRFToken() {
  const csrfToken = cookies.get('spg-csrf-token')

  // remove quotations (if present) before returning
  return csrfToken?.replace(/^"(.+)"$/, '$1') ?? ''
}

export async function fetchApi<ReturnType>(
  url: string,
  options: RequestInit | undefined = {},
  prefixWithOrgKey?: boolean
): Promise<ReturnType> {
  if (prefixWithOrgKey) {
    const orgKey = getCurrentOrgKey()
    invariant(orgKey, 'No organization key found in session')

    url = getBaseUrl({ key: orgKey }) + url
  }

  const response = await fetch(url, {
    ...options,
    headers: {
      ...getRequestHeaders(),
      ...options.headers,
    },
  })

  if (!response.ok) {
    throw new Error(response.statusText)
  }

  if (response.status === 204) {
    return response.text() as ReturnType
  }

  return await response.json()
}
